<template>
  <div class="sidebar-site" v-bind:class="{forceVisible: forceSidebarVisible}">
    <div class="header">
      How can we help you?
    </div>

    <hr class="sidebar-separator"/>

    <div class="nav-wrapper">
      <div class="sidebar-nav-item" v-on:click="getStarted">
        <img src="../assets/images/pencil.svg" class="icon" alt="Get Started!" />
        <span>Get Started!</span>
      </div>
      <div class="sidebar-nav-item" v-on:click="login">
        <img src="../assets/images/user.svg" class="icon" alt="Login" />
        <span>Login</span>
      </div>
      <div class="sidebar-nav-item" v-on:click="landing">
        <img src="../assets/images/home.svg" class="icon" alt="Home" />
        <span>Home</span>
      </div>
      <div class="sidebar-nav-item" v-on:click="about">
        <img src="../assets/images/about-icon.svg" class="icon" alt="About" />
        <span>About</span>
      </div>
      <div class="sidebar-nav-item" v-on:click="faq">
        <img src="../assets/images/question-circle.svg" class="icon" alt="Frequently asked questions" />
        <span>FAQs</span>
      </div>
      <div class="sidebar-nav-item" v-on:click="contact">
        <img src="../assets/images/envelope.svg" class="icon" alt="Contact" />
        <span>Contact</span>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'

export default {
  name: 'SidebarSite',

  data () {
    return {
      forceSidebarVisible: false
    }
  },

  methods: {
    about: function () {
      if (this.$route.path !== '/about') {
        this.$router.push('about')
      }
    },

    contact: function () {
      if (this.$route.path !== '/contact') {
        this.$router.push('contact')
      }
    },

    faq: function () {
      this.$router.push('faq')
    },

    getStarted: function () {
      this.$router.push('get-started')
    },

    landing: function () {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },

    login: function () {
      this.$router.push('login')
    }
  },

  props: ['forceVisible'],

  watch: {
    forceVisible: function (newVal, oldVal) {
      this.forceSidebarVisible = newVal
    }
  }
}
</script>

<style scoped>
  /* Sidebar styles here  */
  .active {
    background: var(--sidebar-button-hover);
    box-shadow: 0px 5px 7px 1px rgba(39,39,39,.3)
  }

  .forceVisible {
    left: 0 !important;
  }

  .icon {
    bottom: 5px;
    height: 22px;
    opacity: .8;
    position: relative;
    vertical-align: middle;
  }

  .logout {
    left: 3px;
    position: relative;
  }

  .header {
    color: var(--sidebar-text);
    padding: 1.25em 1.5em .75em 1.5em;
    position: relative;
  }

  .sidebar-separator {
    background: var(--sidebar-text);
    border: none;
    height: .5px;
    opacity: .5;
    width: 228px;
  }

  .nav-wrapper {
    margin: 10px 0 0 0;
    border-radius: 30px;
    color: #fff;
    display: block;
    text-decoration: none;
    position: relative;
    cursor: pointer;
    font-size: .7142em;
    line-height: 1.625rem;
  }

  .sidebar-site {
    background-color: var(--secondary);
    bottom: 0;
    box-shadow: 3px 0px 9px 0px rgba(0,0,0,.5);
    height: 100%;
    left: 0;
    position: fixed;
    top: 70px;
    transition: all .3s ease 0s;
    width: 260px;
    z-index: 999;
  }

  @media only screen and (max-width: 991px) {
    .sidebar-site {
      left: -260px;
    }
  }

  @media only screen and (min-width: 601px) {
    .sidebar-site {
      display: none;
    }
  }

  .sidebar-nav-item {
    padding: 1.5em 2em;
  }

  .sidebar-nav-item:hover {
    background: var(--sidebar-site-button-hover);
  }

  span {
    font-size: 20px;
    padding-left: .75em;
  }
</style>
